import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import ContentHolder from '../../content-holder/content-holder'
import LessonsHead from '../lessons/lessons-head/lessons-head'
import Lessons from './lessons/lessons.container'

const styles = {
  page: {
    '@media (min-width: 768px)': {
      padding: '0 0 60px'
    }
  },
  contentHolder: {
    marginTop: '40px',
    '@media (min-width: 768px)': {
      marginTop: '60px'
    }
  }
}

const LessonsList = ({ classes }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <LessonsHead />
      <div className={classes.page}>
        <ContentHolder className={classes.contentHolder}>
          <Lessons />
        </ContentHolder>
      </div>
    </>
  )
}

export default injectSheet(styles)(LessonsList)
